import { render } from "./Requested.vue?vue&type=template&id=49dcebb7"
import script from "./Requested.vue?vue&type=script&lang=js"
export * from "./Requested.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__